import templateUrl from './payroll-select.component.html'
import './payroll-select.component.less'

export const PayrollSelectComponent = {
    controller: PayrollSelectController,
    templateUrl,
    bindings: {
        payroll: "=",
        pristinePayrolls: "<payrolls",
        placeholder: "@?",
        optionLabel: "<?",
        changePayroll: "&onChangePayroll"
    }
}

function PayrollSelectController() {
    const $ctrl = this;

    $ctrl.$onInit = onInit;
    $ctrl.$onChanges = onChanges;
    $ctrl.payroll;
    $ctrl.payrolls = [];
    $ctrl.placeholder;
    $ctrl.kendoDropDownListOptions = {};
    $ctrl.onChangePayroll = onChangePayroll;

    function onInit() {
        $ctrl.kendoDropDownListOptions.valueTemplate =
            document.getElementById("payrollSelectValueTemplate.html").innerText;
        $ctrl.kendoDropDownListOptions.template =
            document.getElementById("payrollSelectTemplate.html").innerText;
        if ($ctrl.optionLabel) {
            $ctrl.kendoDropDownListOptions.optionLabel = $ctrl.optionLabel;
        }
        if ($ctrl.pristinePayrolls) {
            // Update the list of divisions that appear in the list. Precompute information
            // such as whether the division profile name is needed to disambiguate between divisions.
            $ctrl.divisions = reduceDivisionList($ctrl.payrolls);
            // Reassign the entire list to trigger kendo rebind.
            $ctrl.payrolls = $ctrl.pristinePayrolls.map(mapPayrollVM);
        }
    }

    function onChanges(changesObj) {
        if (changesObj.optionLabel) {
            $ctrl.kendoDropDownListOptions.optionLabel = $ctrl.optionLabel;
        }
        if (changesObj.pristinePayrolls && $ctrl.pristinePayrolls) {
            // Recompile division aggregate information
            $ctrl.divisions = reduceDivisionList($ctrl.pristinePayrolls)
            // Reassign the entire list to trigger kendo rebind.
            $ctrl.payrolls = $ctrl.pristinePayrolls.map(mapPayrollVM);
        }
    }

    function mapPayrollVM(payroll) {
        return {
            ...payroll,
            DivisionCountries: !payroll.DivisionCountries ? [] : payroll.DivisionCountries.map(dc => ({
                ...dc,
                showCountryName: hasMultipleDivisionCountries(dc)
            })),
            divisionNames: joinDivisionNames(payroll.DivisionCountries)
        };
    }

    function onChangePayroll() {
        $ctrl.changePayroll({ payroll: $ctrl.payroll });
    }

    function reduceDivisionList(payrolls) {
        const { divisions } = payrolls.reduce((ag, payroll) => {
            if (!payroll.DivisionCountries) return ag;
            for (const profile of payroll.DivisionCountries) {
                if (!ag.divisionIDs.has(profile.DivisionID)) {
                    const division = {
                        divisionID: profile.DivisionID,
                        name: profile.DivisionName,
                        // Count the number of distinct profiles that appear in the payroll list.
                        profileCount: countProfilesPerDivision(profile.DivisionID, payrolls)
                    }
                    ag.divisionIDs.add(profile.DivisionID);
                    ag.divisions[profile.DivisionID] = division
                }
            }
            return ag
        }, { divisionIDs: new Set(), divisions: {} });
        return divisions;
    }

    /**
     * Return the number of distinct profiles of the given division that appears in the
     * given payroll list.
     * @param {number} divisionID The division ID used for grouping divisions.
     * @param {any[]} payrolls The list of payrolls containing division country list data.
     */
    function countProfilesPerDivision(divisionID, payrolls) {
        return payrolls.reduce((ag, payroll) => {
            if (!payroll.DivisionCountries) return ag;
            const profilesOfDivision = payroll.DivisionCountries.filter(p => p.DivisionID === divisionID)
            for (const profile of profilesOfDivision) {
                if (!ag.divisionProfileIDs.has(profile.DivisionProfileID)) {
                    ag.divisionProfileIDs.add(profile.DivisionProfileID)
                    ag.count++;
                }
            }
            return ag
        }, { divisionProfileIDs: new Set(), count: 0 }).count
    }

    /**
     * Return whether there are any payrolls that use a different profile of the same division.
     * @param {any} divisionCountry
     */
    function hasMultipleDivisionCountries(divisionCountry) {
        const division = $ctrl.divisions[divisionCountry.DivisionID]
        return division && division.profileCount
    }

    /**
     * Return the names of each division country, joined together.
     * @param {any} divisionCountries
     */
    function joinDivisionNames(divisionCountries) {
        if (!divisionCountries) return "";
        return divisionCountries.map(function (divisionCountry) {
            const hasMultipleCountries = $ctrl.divisions[divisionCountry.DivisionID].profileCount > 1;
            return divisionCountry.DivisionName + (hasMultipleCountries ? " (" + divisionCountry.CountryName + ")" : "");
        }).join(", ");
    }
}
